/*rootファイル*/

import './App.css';
import Header from "./Header";
import { Routes, Route, Navigate } from 'react-router-dom';
import Event from './Event/Event';
import EventCreatePage from './/EventCreatePage/EventCreatePage';
import EventEditPage from './Event/EventEditPage';
import FirstPage from './FirstPage';

//import db from "./firebase";
//import { doc, collection, getDocs, onSnapshot, addDoc } from "firebase/firestore"; 



function App() {
  /*const [posts, setPosts] = useState([]);
  const [title, setTitle] = useState("");  // 入力用 state
  const [text, setText] = useState("");    // 入力用 state*/


  return (
    <div className='App'>
      <Header />
      <div>
        <Routes>
          <Route path="/" element={<Navigate to="/EventCreatePage" replace />} />
          <Route path="/EventCreatePage" element={<EventCreatePage />} />
          <Route path="/event/:id" element={<Event />} />
          <Route path="/event/:id/edit" element={<EventEditPage />} />
          <Route path="/FirstPage" element={<FirstPage />} />
        </Routes>
      </div>
    </div>
  );

  
}

export default App;
